'use client';

import { Field } from '@ctct/summit-core';
import { ColorPicker } from '@ctct/summit-extended';
import { type ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';

const ColorPickerInput = ({
  formKey,
  registerOpts,
  className,
  ...inputProps
}: InputOpts & ComponentProps<typeof ColorPicker>) => {
  const { control } = useFormContext();
  return (
    <Field className={className}>
      <Controller
        name={formKey}
        control={control}
        rules={registerOpts}
        render={({ field: { onChange: handleChange, value } }) => {
          return (
            <ColorPicker
              {...inputProps}
              color={value}
              onColorSelect={handleChange}
              className="r:w-60"
            />
          );
        }}
      />
    </Field>
  );
};

export { ColorPickerInput };
